import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PublicNavbar from "@/components/layout/PublicNavbar";

export default function LeadQualificationPage() {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-agent-background text-agent-text pt-16">
        <div className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-agent-primary">AI-Powered</span> Lead
              Qualification
            </h1>
            <p className="text-xl text-agent-muted mb-12">
              Automate your lead qualification process with intelligent AI
              agents that can engage with potential customers, qualify leads,
              and schedule meetings.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-agent-card border border-agent-border p-8 rounded-xl">
                <h2 className="text-2xl font-bold mb-4">Key Features</h2>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>24/7 lead engagement</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>Natural voice conversations</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>Intelligent lead scoring</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-primary mr-3"></div>
                    <span>Automated meeting scheduling</span>
                  </li>
                </ul>
              </div>

              <div className="bg-agent-card border border-agent-border p-8 rounded-xl">
                <h2 className="text-2xl font-bold mb-4">Benefits</h2>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Reduce response time</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Increase conversion rates</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Scale your sales operations</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-agent-secondary mr-3"></div>
                    <span>Focus on qualified leads</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center">
              <Link to="/signup">
                <Button className="bg-agent-primary hover:bg-agent-primary/80 text-black font-medium px-8 py-6 text-lg">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
